export default __webpack_public_path__ + "static/media/mod-degerlendir.bf662fe0.png";